import { CustomColors } from '@mui/material';
import { PaletteMode, PaletteOptions } from '@mui/material/styles';

/** Извлекает кастомные цвета палитры */
type CustomColorsKeys = keyof Pick<PaletteOptions, keyof CustomColors>;
/**  */
type PaletteColors = Record<CustomColorsKeys, Record<PaletteMode, string>>;

/**
 * @description Можно использовать и в scss c префиксом --ucr-palette-
 */
export const ucrPaletteColors: PaletteColors = {
  // -- Text
  'text-black': { light: '#0E0F10', dark: '#FAFAFD' },
  'text-grey-500': { light: '#23252D', dark: '#E7E7F0' },
  'text-grey-400': { light: '#676C84', dark: '#C7D1E1' },
  'text-grey-350': { light: '#8E97A4', dark: '#C7D1E1' },
  'text-grey-300': { light: '#B5BED0', dark: '#97A3B6' },
  'text-blue-050': { light: '#546FFF', dark: '#465AC2' },
  'text-blue-100': { light: '#314FED', dark: '#5C74F5' },
  'text-blue-200': { light: '#0D2FD0', dark: '#C5CEFF' },
  'text-red-050': { light: '#FC837B', dark: '#F54D42' },
  'text-red-100': { light: '#FD3B3B', dark: '#F54D42' },
  'text-red-200': { light: '#D73026', dark: '#F86259' },
  'text-green-050': { light: '#88E4C9', dark: '#2EA481' },
  'text-green-100': { light: '#00D3A1', dark: '#27CE9C' },
  'text-green-200': { light: '#159A72', dark: '#5BE9BE' },
  'text-yellow-050': { light: '#F5D98E', dark: '#BC983B' },
  'text-yellow-100': { light: '#EEC04B', dark: '#FFC93F' },
  'text-yellow-200': { light: '#C59928', dark: '#FFDD87' },
  'text-white': { light: '#FFFFFF', dark: '#0E0E10' },

  // -- Card
  'card-white-trans': { light: '#FFFFFF1F', dark: '#343541' },
  'card-white': { light: '#FFFFFF', dark: '#24252D' },
  'card-grey-100': { light: '#F1F4FF', dark: '#202027' },
  'card-grey-150': { light: '#ECF1FE', dark: '#292B31' },
  'card-grey-200': { light: '#D6E3EF', dark: '#434B55' },
  'card-grey-500': { light: '#23252D', dark: '#C4CBD8' },
  'card-blue-000': { light: '#D7DEF8', dark: '#273845' },
  'card-red-000': { light: '#FFE5E3', dark: '#361D18' },
  'card-green-000': { light: '#D9F6EE', dark: '#163329' },
  'card-yellow-000': { light: '#FEF5DF', dark: '#382F16' },
  'card-magenta-000': { light: '#F5EDFF', dark: '#36204B' },

  // -- Button
  'button-grey-500': { light: '#23252D', dark: '#E7E7F0' },
  'button-grey-400': { light: '#676C84', dark: '#C7D1E1' },
  'button-grey-300': { light: '#B5BED0', dark: '#97A3B6' },
  'button-grey-150': { light: '#E1ECF5', dark: '#292B31' },
  'button-blue-050': { light: '#546FFF', dark: '#465AC2' },
  'button-blue-100': { light: '#314FED', dark: '#5C74F5' },
  'button-blue-200': { light: '#0D2FD0', dark: '#C5CEFF' },
  'button-red-050': { light: '#FC837B', dark: '#F54D42' },
  'button-red-100': { light: '#FD3B3B', dark: '#F54D42' },
  'button-red-200': { light: '#D73026', dark: '#F86259' },
  'button-green-050': { light: '#88E4C9', dark: '#2EA481' },
  'button-green-100': { light: '#00D3A1', dark: '#27CE9C' },
  'button-green-200': { light: '#159A72', dark: '#5BE9BE' },
  'button-yellow-050': { light: '#F5D98E', dark: '#BC983B' },
  'button-yellow-100': { light: '#EEC04B', dark: '#FFC93F' },
  'button-yellow-200': { light: '#C59928', dark: '#FFDD87' },
  'button-white': { light: '#FFFFFF', dark: '#FFFFFF' },

  // -- Icons
  'icon-grey-500': { light: '#23252D', dark: '#E7E7F0' },
  'icon-grey-400': { light: '#676C84', dark: '#C7D1E1' },
  'icon-grey-300': { light: '#B5BED0', dark: '#97A3B6' },
  'icon-blue-050': { light: '#546FFF', dark: '#465AC2' },
  'icon-blue-100': { light: '#314FED', dark: '#5C74F5' },
  'icon-blue-200': { light: '#0D2FD0', dark: '#C5CEFF' },
  'icon-red-050': { light: '#FC837B', dark: '#F54D42' },
  'icon-red-100': { light: '#FD3B3B', dark: '#F54D42' },
  'icon-red-200': { light: '#D73026', dark: '#F86259' },
  'icon-green-050': { light: '#88E4C9', dark: '#2EA481' },
  'icon-green-100': { light: '#00D3A1', dark: '#27CE9C' },
  'icon-green-200': { light: '#159A72', dark: '#5BE9BE' },
  'icon-yellow-050': { light: '#F5D98E', dark: '#BC983B' },
  'icon-yellow-100': { light: '#EEC04B', dark: '#FFC93F' },
  'icon-yellow-200': { light: '#C59928', dark: '#FFDD87' },
  'icon-white': { light: '#FFFFFF', dark: '#FFFFFF' },

  // -- Line
  'line-grey-400': { light: '#676C84', dark: '#C7D1E1' },
  'line-grey-300': { light: '#B5BED0', dark: '#97A3B6' },
  'line-grey-200': { light: '#D6E3EF', dark: '#434B55' },
  'line-grey-150': { light: '#E1ECF5', dark: '#292B31' },
  'line-white-trans': { light: '#FFFFFF80', dark: '#292B31' },
  'line-blue-050': { light: '#546FFF', dark: '#465AC2' },
  'line-blue-100': { light: '#314FED', dark: '#5C74F5' },
  'line-blue-200': { light: '#0D2FD0', dark: '#C5CEFF' },
  'line-red-050': { light: '#FC837B', dark: '#F54D42' },
  'line-red-100': { light: '#FD3B3B', dark: '#F54D42' },
  'line-red-200': { light: '#D73026', dark: '#F86259' },
  'line-green-050': { light: '#88E4C9', dark: '#2EA481' },
  'line-green-100': { light: '#00D3A1', dark: '#27CE9C' },
  'line-green-200': { light: '#159A72', dark: '#5BE9BE' },
  'line-yellow-050': { light: '#F5D98E', dark: '#BC983B' },
  'line-yellow-100': { light: '#EEC04B', dark: '#FFC93F' },
  'line-yellow-200': { light: '#C59928', dark: '#FFDD87' },

  // -- Background
  'background-white': { light: '#FFFFFF', dark: '#2B3033' },
  'background-dark-modal': { light: '#52687580', dark: '#526875B3' },
  'background-light-modal': { light: '#819DAD3D', dark: '#768E9C80' },

  // -- Shadow
  'shadow-grey-300': { light: '#B5BED0', dark: '#97A3B6' },
  'shadow-grey-200': { light: '#D6E3EF', dark: '#434B55' },
  'shadow-grey-150': { light: '#E1ECF5', dark: '#292B31' },
  'shadow-white': { light: '#FFFFFF', dark: '#0E0E10' },
};
